/**
 * Cookies & Storage Helper Utilities
 *
 * Helper functions for formatting and validating cookies/localStorage data.
 * (Web version - no loadFromCurrentTab functionality)
 */

/**
 * Format a storage value for display (truncate if too long)
 * @param {string} value - The value to format
 * @param {number} maxLength - Maximum length before truncation
 * @returns {string} Formatted value
 */
export function formatStorageValue(value, maxLength = 50) {
  if (!value) return "";
  if (value.length <= maxLength) return value;
  return value.substring(0, maxLength) + "...";
}

/**
 * Check if a value looks like JSON
 * @param {string} value - The value to check
 * @returns {boolean}
 */
export function isJsonValue(value) {
  if (!value) return false;
  const trimmed = value.trim();
  return (trimmed.startsWith("{") && trimmed.endsWith("}")) || (trimmed.startsWith("[") && trimmed.endsWith("]"));
}
